<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='读经亮光' subPath='每日背经'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-button type="primary" @click="showAddDialog">添加每日背经</el-button>
        </el-col>
      </el-row>
      <el-table :data="dailyList" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">
            {{scope.row.day_time*1000 | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic!=''" :src="scope.row.pic+'?imageView2/0/w/100'"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="chapter" label="章节" align="center"></el-table-column>
        <el-table-column prop="content" label="经文" align="center"></el-table-column>
        <el-table-column prop="hits" label="点击量" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
    <light-reading-daily-add :id="currentId"
      :visible="addDialogAvaible"
      @closeDialog="closeDialog"
      @update="updateDaily"
      @add="addDaily"></light-reading-daily-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import LightReadingDailyAdd from './LightReadingDailyAdd.vue'
export default {
  name: 'light_reading_daily_list',
  components: {
    'bread-crumb': BreadCrumb,
    'light-reading-daily-add': LightReadingDailyAdd
  },
  created () {
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      dailyList: [],
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/light_reading_daily/list', this.param)
      if (res.code === 0) {
        this.dailyList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    async addDaily (data) {
      const res = await this.$http.post('/admin/light_reading_daily/add', data)
      if (res.code === 0) {
        this.closeDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateDaily (id, data) {
      const res = await this.$http.post('/admin/light_reading_daily/update/' + id, data)
      if (res.code === 0) {
        this.closeDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/light_reading_daily/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style>
</style>
